import React, { FC } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../constants';

interface UpdatesDropdownProps {
  children: React.ReactNode;
  onClick?: () => void;
}

export const UpdatesDropdown: FC<UpdatesDropdownProps> = ({
  children,
  onClick,
}) => {
  return (
    <UpdatesDropdownContainer onClick={onClick}>
      {children}
    </UpdatesDropdownContainer>
  );
};

const UpdatesDropdownContainer = styled.div`
  border: 1px solid ${COLORS.INDUSTRY_BORDER};
  position: absolute;
  z-index: 20;
  top: 80px;
  right: 0px;
  background-color: ${COLORS.WHITE};
  padding: 40px;
  width: 100%;
  max-width: 488px;
  box-sizing: border-box;
`;
